import script from "./MaterialAIMt.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaterialAIMt.vue?vue&type=script&lang=ts&setup=true"

import "./MaterialAIMt.vue?vue&type=style&index=0&id=0136b0e8&scoped=true&lang=less"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0136b0e8"]])

export default __exports__